import { render, staticRenderFns } from "./BaseCombobox.vue?vue&type=template&id=95e31ec4"
import script from "./BaseCombobox.vue?vue&type=script&lang=js"
export * from "./BaseCombobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95e31ec4')) {
      api.createRecord('95e31ec4', component.options)
    } else {
      api.reload('95e31ec4', component.options)
    }
    module.hot.accept("./BaseCombobox.vue?vue&type=template&id=95e31ec4", function () {
      api.rerender('95e31ec4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseCombobox.vue"
export default component.exports